<template>
  <section class="news-section about-footer-bg" v-if="this.load">
      <header-inner/>
    <!--Шапка-->
    <section class="header-bg">
      <wrapper>
        <about-menu @currentMenu="currentMenu($event)"/>
         <div class="block desktop">
             <h1 class="text-blue-2 title-upper font-bold" v-html="about.block_title"></h1>
             <nuxt-link :to="'/products/outdoor'" class="btn solid--green large">Узнать о продуктах</nuxt-link>
         </div>
      </wrapper>
    </section>

    <!--./Шапка-->
    <wrapper :lineBorders="false" :lineCenter="true" class="page--top page--bottom footer-bg" v-if="true">
      <h1 class="text-blue-2 title-upper mobile title-main"  v-html="about.block_title"></h1>
      <section class="typography-text" >
         <div v-html="about.text"></div>
         <div class="buttons text-center">
            <nuxt-link :to="'/products/outdoor'" class="btn solid--green large">Узнать о продуктах</nuxt-link>
         </div>
      </section>
    </wrapper>
  </section>

</template>

<script>
  import HeaderInner from '~/components/header/HeaderInner'
  import HeaderImage from '~/components/header/HeaderImage'
  import AboutMenu from '~/components/about/AboutMenu'

  export default {


    async asyncData({ $axios, app, route, redirect, store, query }) {
      await Promise.all([
        store.dispatch('company/aboutOne'),
      ]);
       const about = store.getters['company/aboutOne']['item'];
        let seoPage = {}
        try {
            seoPage = await $axios.$get(`${process.env.apiUrl}/methods/site/get_page_info/?link=${route.path}`,
                {
                    timeout: 1000 * 5, // Wait for 5 seconds
                }
            );
            return {about,seoPage}
        } catch (e) {
            seoPage = {id:  '', title: '', description: '', keywords: ''}
            return {about,seoPage};
        }
    },
    data() {
      return {
        seoMenu: {
          title: '',
          description: '',
          keywords: '',
        }
      };
    },

    head () {
      if(this.seoPage) {
        return {
          title: this.seoPage.title,
          link: [{rel: 'canonical', href: process.env.base + this.$route.path}],
          meta: [
            {
              hid: `description`,
              name: `description`,
              content: this.seoPage.description
            },
            {
              hid: `keywords`,
              name: 'keywords',
              content: this.seoPage.keywords
            }
          ]
        }
      }
    },
    components: {
      HeaderInner,
      HeaderImage,
      AboutMenu,
    },
    computed: {
      load() {
        return this.$store.getters['company/aboutOne']['loaded']
      },
      getAbout() {
        return this.load ? this.$store.getters['company/aboutOne']['item'] : []
      },
    },
    methods: {
      currentMenu(event) {
         this.seoMenu.title = event ? event.title : ''
         this.seoMenu.description = event ? event.description : ''
         this.seoMenu.keywords = event ? event.keywords : ''
      }
    },
    mounted() {
     // if(!this.load) this.$store.dispatch('company/aboutOne');
    },
  };

</script>

<style lang="scss" scoped>
  @import "../../assets/vars", "../../assets/mixins";

  .header-bg {
    margin-top: 60px;
    @include background-cover("/images/about/header-bg.png");
     background-position: top center;
     background-repeat: no-repeat;
     width: 100%;
     height: 73vw;

     .block {
       //margin-top: 70px;
       margin-left: 22%;
       .btn {
         margin-top: 40px;
       }
     }
  }

  .buttons {
     margin-top: 30px;
  }
  .page--bottom {
     padding-bottom: 280px;
  }
  .about-footer-bg {
    background:url("/images/about/footer-bg.png") no-repeat;
    background-position: bottom right;

  }
  @media (max-width: $media_md) {
    .header-bg {
      height: 80vw;
    }
    h1 {
      text-transform: none;
    }
    .about-footer-bg {
       background: $color-white;
    }
    .page--bottom {
      padding-bottom: 50px;
    }
  }
  @media (max-width: $media_sm) {
    .header-bg {
      margin-top: 30px;
    }
  }
  @media (max-width: $media_xs) {
    h1 {
      text-transform: none;
    }
    .page--top {
      padding-top: 20px;
    }
    .header-bg {
      min-height: 265px;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/company/index.vue